import React, { useState, useEffect } from 'react';
// import cn from 'classnames';

import ImageInput from '../ImageInput/ImageInput';
import styles from './BlogForm.module.css';

const DishImage = (props) => {
  const { 
    initialValues, 
    onChange,
    id,
  } = props;

  const [image, setImage] = useState(initialValues || '');

  useEffect(() => {
    onChange(image);
  }, [image]);

  return (
    <div className={styles.dishImageBlock}>
      <ImageInput 
        value={image}
        onChange={setImage}
        name={`image${id}`}
        label="Upload"
      />
    </div>
  );
};

export default DishImage;
